import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EcologicalZoneCard = ({ zone, onExplore, onARPreview }) => {
  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic group">
      <div className="relative h-64 overflow-hidden">
        <Image
          src={zone?.image}
          alt={zone?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 animation-organic"
        />
        <div className="absolute inset-0 gradient-conservation opacity-60 group-hover:opacity-40 animation-organic"></div>
        
        {/* Zone Badge */}
        <div className="absolute top-4 left-4 bg-primary px-3 py-1 rounded-full">
          <span className="text-xs font-medium text-primary-foreground">{zone?.category}</span>
        </div>

        {/* Season Indicator */}
        {zone?.bestSeason && (
          <div className="absolute top-4 right-4 bg-accent px-3 py-1 rounded-full flex items-center gap-1">
            <Icon name="Calendar" size={14} color="var(--color-accent-foreground)" />
            <span className="text-xs font-medium text-accent-foreground">{zone?.bestSeason}</span>
          </div>
        )}

        {/* Quick Stats Overlay */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
          <div className="flex items-center gap-4 text-white text-sm">
            <div className="flex items-center gap-1">
              <Icon name="Trees" size={16} />
              <span>{zone?.speciesCount} Species</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="MapPin" size={16} />
              <span>{zone?.area}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-foreground mb-2">{zone?.name}</h3>
        <p className="text-muted-foreground text-sm mb-4 line-clamp-3">{zone?.description}</p>

        {/* Key Features */}
        <div className="flex flex-wrap gap-2 mb-4">
          {zone?.features?.slice(0, 3)?.map((feature, index) => (
            <span
              key={index}
              className="text-xs bg-muted px-2 py-1 rounded text-muted-foreground"
            >
              {feature}
            </span>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2">
          <Button
            variant="default"
            size="sm"
            iconName="Eye"
            iconPosition="left"
            onClick={() => onExplore(zone)}
            className="flex-1"
          >
            Explore Zone
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Smartphone"
            onClick={() => onARPreview(zone)}
          >
            AR
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EcologicalZoneCard;